import { createAction, props } from '@ngrx/store';
import { IProducts } from '../models/products.model';

export const loadUpcomingProductsFromSomeoneElse = createAction(
  '[UpcomingProductsFromSomeoneElse] Load UpcomingProductsFromSomeoneElse',
  props<{ request: string }>()
);

export const loadUpcomingProductsFromSomeoneElseSuccess = createAction(
  '[UpcomingProductsFromSomeoneElse] Load UpcomingProductsFromSomeoneElse Success',
  props<{ response: IProducts[] }>()
);

export const loadUpcomingProductsFromSomeoneElseFailure = createAction(
  '[UpcomingProductsFromSomeoneElse] Load UpcomingProductsFromSomeoneElse Failure',
  props<{ error: Error | any }>()
);
